import { useAuthStore } from '@/stores/authStore'
import { usePlatformContextStore } from '@/stores/platformContextStore'

/**
 * Defence in depth for issue #301: the primary fix is resetClientState() on
 * every identity/tenant change, but a key that names its tenant and user can
 * never collide with another identity's entry even if a reset is missed.
 *
 * Returns the identity prefix ['scope', tenant, user]. Platform admins
 * impersonating a tenant send X-Target-Tenant-ID, so that target counts as
 * their tenant. Read at call time (keys are built during render, and every
 * identity change also re-renders consumers of the auth store).
 */
export function scopePrefix(): readonly ['scope', string, string] {
  const user = useAuthStore.getState().user
  const target = usePlatformContextStore.getState().selectedTenantId
  const tenant = user?.tenantId || target || 'none'
  return ['scope', tenant, user?.id ?? 'anon'] as const
}

/** Scope a key factory root: scopedKey('clusters') -> ['scope', t, u, 'clusters']. */
export function scopedKey<T extends string>(root: T) {
  return [...scopePrefix(), root] as const
}
